import React, { FC, InputHTMLAttributes } from "react";
import {
  InputGroup,
  InputLeftElement,
  InputRightAddon,
} from "@chakra-ui/react";
import { NumberInput } from "../NumberInput/NumberInput";

export interface NumberInputWithElementProps
  extends InputHTMLAttributes<HTMLInputElement> {
  icon?: JSX.Element;
  width?: string;
  inputStyle?: React.CSSProperties;
  suffix?: string;
}

export const NumberInputWithElement: FC<NumberInputWithElementProps> = ({
  icon,
  width,
  inputStyle,
  suffix,
  ...inputProps
}) => {
  return (
    <InputGroup
      w={width}
      {...(suffix
        ? {
            border: "1px solid #D5D7DA",
            borderRadius: "8px",
            overflow: "hidden",
            _focusWithin: {
              border: "2px solid",
              borderColor: "newBlue.500",
              boxShadow: "0px 4px 10px rgba(40, 103, 149, 0.1)",
            },
            sx: {
              "input, input:focus": {
                border: "none !important",
                boxShadow: "none !important",
              },
            },
          }
        : {})}
    >
      {icon && (
        <InputLeftElement
          color="newBlue.500"
          pointerEvents="none"
          children={icon}
        />
      )}
      <NumberInput
        inputStyle={{
          ...inputStyle,
          ...(suffix
            ? { borderRadius: "8px 0 0 8px", borderRight: "none" }
            : {}),
        }}
        {...inputProps}
      />
      {suffix && (
        <InputRightAddon
          backgroundColor={inputStyle?.backgroundColor || "#f0f1f2"}
          border="none"
          color={inputStyle?.color || "rgba(30, 82, 151, 0.8)"}
          fontSize={14}
          px={2}
          minW="fit-content"
        >
          {suffix}
        </InputRightAddon>
      )}
    </InputGroup>
  );
};
